<template>
    <div>
        <div v-if="!multipleOptions.includes(tipoPergunta)">
            <VerifiedLable :title="answer.descricao" disableMLtitle />
        </div>
        <!-- TEXT -->
        <div v-if="tipoPergunta === 'TEXT' && isLoaded">
            <v-input
                v-model="answer.formRespostaPreenchida.resposta"
                ref="shortanswerinput"
                placeholder="placeholder-preencha"
                :maxlength="255"
                :required="obrigatorio"
                :invalid="obrigatorio && isNull(answer.formRespostaPreenchida.resposta)"
                @input="forceReloadProp()"
                :disabled="!isLoaded || isFinalizado"
            />
        </div>

        <!-- TEXTOLONG -->
        <div v-else-if="tipoPergunta === 'MULTITEXT' && isLoaded">
            <v-textarea
                v-model="answer.formRespostaPreenchida.resposta"
                ref="longanswerinput"
                placeholder="placeholder-preencha"
                :rows="4"
                :maxRows="4"
                :maxlength="255"
                :required="obrigatorio"
                :invalid="obrigatorio && isNull(answer.formRespostaPreenchida.resposta)"
                @input="forceReloadProp()"
                :disabled="!isLoaded || isFinalizado"
            />
        </div>

        <!-- INTEGER -->
        <div v-else-if="tipoPergunta === 'INTEGER' && isLoaded">
            <v-money
                v-model="answer.formRespostaPreenchida.resposta"
                placeholder="Digite um número"
                :precision="0"
                :required="obrigatorio"
                :invalid="obrigatorio && isNull(answer.formRespostaPreenchida.resposta)"
                @input="forceReloadProp()"
                :disabled="!isLoaded || isFinalizado"
            />
        </div>

        <!-- DECIMAL -->
        <v-money
            v-else-if="tipoPergunta === 'DECIMAL' && isLoaded"
            v-model="answer.formRespostaPreenchida.resposta"
            placeholder="Digite um valor"
            :required="obrigatorio"
            :invalid="obrigatorio && isNull(answer.formRespostaPreenchida.resposta)"
            @input="forceReloadProp()"
            :disabled="!isLoaded || isFinalizado"
        />

        <!-- PERCENT -->
        <v-money
            v-else-if="tipoPergunta === 'PERCENT' && isLoaded"
            v-model="answer.formRespostaPreenchida.resposta"
            :suffix="'%'"
            placeholder="Digite um valor"
            :required="obrigatorio"
            :invalid="obrigatorio && isNull(answer.formRespostaPreenchida.resposta)"
            @input="forceReloadProp()"
            :disabled="!isLoaded || isFinalizado"
        />

        <!-- DATE -->
        <verified-date-picker
            v-else-if="tipoPergunta === 'DATE' && isLoaded"
            v-model="answer.formRespostaPreenchida.resposta"
            :showClean="true"
            placeholder="selecione-uma-data"
            inForm
            title=""
            :addDateYears="20"
            :required="obrigatorio"
            :invalid="obrigatorio && isNull(answer.formRespostaPreenchida.resposta)"
            @input="forceReloadProp()"
            :disabled="!isLoaded || isFinalizado"
        />

        <!-- DATETIME -->
        <div v-else-if="tipoPergunta === 'DATETIME' && isLoaded" class="columns">
            <div class="column is-6">
                <verified-date-picker
                    v-model="respostaData"
                    :showClean="true"
                    placeholder="selecione-uma-data"
                    inForm
                    title=""
                    :addDateYears="20"
                    :required="obrigatorio"
                    :invalid="obrigatorio && isNull(respostaData)"
                    @input="datetimeFillAndVerify()"
                    :disabled="!isLoaded || isFinalizado"
                />
            </div>
            <div class="column is-3">
                <VerifiedTimePicker
                    v-model="respostaHora"
                    :invalid="respostaHora.HH == '' || respostaHora.mm == ''"
                    hideClearButton
                    :required="obrigatorio"
                    @input="datetimeFillAndVerify()"
                    :disabled="!isLoaded || isFinalizado"
                />
            </div>
        </div>

        <!-- COMBOBOX -->
        <div v-else-if="tipoPergunta === 'COMBOBOX' && isLoaded">
            <vss-select
                title=""
                v-model="respostaCombobox"
                :options="options"
                label="descricao"
                clearable
                :required="obrigatorio"
                :invalid="obrigatorio && isNull(respostaCombobox)"
                @input="comboboxFillAndVerify($event)"
                :disabled="!isLoaded || isFinalizado"
            />
        </div>

        <!-- RADIO -->
        <div v-else-if="tipoPergunta === 'RADIO' && isLoaded">
            <div v-for="option in options" :key="option.id">
                <b-radio 
                    v-model="respostaRadio" 
                    :native-value="option.descricao" 
                    @input="radioFillAndVerify($event)"
                    :disabled="!isLoaded || isFinalizado"
                >
                    {{ option.descricao }}
                </b-radio>
            </div>
            <span v-if="obrigatorio && !radioValidated" class="validation" v-text="$t('msg-campo-obrigatorio')" />
            <div class="clearfix" v-else />
        </div>

        <!-- SWITCH -->
        <div v-else-if="tipoPergunta === 'SWITCH' && isLoaded">
            <div v-for="option in options" :key="option.id">
                <b-switch
                    v-model="option.formRespostaPreenchida.situacao"
                    :true-value="1"
                    :false-value="0"
                    @input="switchFillAndVerify($event)"
                    :disabled="!isLoaded || isFinalizado"
                >
                    {{ option.descricao }}
                </b-switch>
            </div>
            <span v-if="obrigatorio && !switchValidated" class="validation" v-text="$t('msg-campo-obrigatorio')" />
            <div class="clearfix" v-else />
        </div>

        <!-- CHECKBOX -->
        <div v-else-if="tipoPergunta === 'CHECKBOX' && isLoaded">
            <div v-for="option in options" :key="option.id">
                <b-checkbox
                    v-model="option.formRespostaPreenchida.situacao"
                    :true-value="1"
                    :false-value="0"
                    @input="checkBoxFillAndVerify($event)"
                    :disabled="!isLoaded || isFinalizado"
                >
                    {{ option.descricao }}
                </b-checkbox>
            </div>
            <span v-if="obrigatorio && !checkBoxValidated" class="validation" v-text="$t('msg-campo-obrigatorio')" />
            <div class="clearfix" v-else />
        </div>
    </div>
</template>

<script>
import VerifiedTimePicker from "@/components/shared/form/VerifiedTimePicker.vue";
import VerifiedLable from "@/components/shared/VerifiedLable.vue";

export default {
    components: {
        VerifiedTimePicker,
        VerifiedLable,
    },
    props: {
        answer: {
            type: Object,
            default: null,
        },
        tipoPergunta: {
            type: String,
            default: "",
        },
        options: {
            type: Array,
            default: () => [],
        },
        obrigatorio: {
            type: Boolean,
            default: false,
        },
        //Lista de campos de multipla seleção
        multipleOptions: {
            type: Array,
            default: () => [],
        },
        isFinalizado: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            respostaRadio: null,
            respostaData: null,
            respostaHora: {
                HH: "",
                mm: "",
            },
            respostaCombobox: null,
            switchValidated: true,
            radioValidated: true,
            checkBoxValidated: true,
            dateTimeValidated: true,
            isLoaded: false,
        };
    },
    created() {
        if(this.tipoPergunta == "DATE") {
            if(!this.isNull(this.answer.formRespostaPreenchida.resposta)) {
                this.answer.formRespostaPreenchida.resposta = new Date(this.answer.formRespostaPreenchida.resposta);
            }
        } else if(this.tipoPergunta == "DATETIME") {
            if(!this.isNull(this.answer.formRespostaPreenchida.resposta)) {
                this.respostaData = new Date(this.answer.formRespostaPreenchida.resposta);
                this.respostaHora.HH =
                    this.respostaData.getHours() < 10
                        ? '0' + this.respostaData.getHours().toString()
                        : this.respostaData.getHours().toString();
                this.respostaHora.mm =
                    this.respostaData.getMinutes() < 10
                        ? '0' + this.respostaData.getMinutes().toString()
                        : this.respostaData.getMinutes().toString();
            }
        } else if(this.tipoPergunta == "RADIO") {
            this.options.forEach(element => {
                if (!this.isNull(element.formRespostaPreenchida.resposta)) {
                    if (element.formRespostaPreenchida.situacao) {
                        this.respostaRadio = element.formRespostaPreenchida.resposta;
                    } else {
                        element.formRespostaPreenchida.resposta = null;
                    }
                }
            });
        } else if (this.tipoPergunta == "COMBOBOX") {
            this.options.forEach(element => {
                if (!this.isNull(element.formRespostaPreenchida.resposta)) {
                    if (element.formRespostaPreenchida.situacao) {
                        this.respostaCombobox = { ...element };
                    } else {
                        element.formRespostaPreenchida.resposta = null;
                    }
                }
            });
        }
        
        this.isLoaded = true;
    },
    methods: {
        forceReloadProp() {
            this.$forceUpdate();
        },
        datetimeFillAndVerify() {
            this.dateTimeValidated = true;

            if (this.respostaHora.HH == "" || this.respostaHora.mm == "") {
                this.dateTimeValidated = false;
            }

            if (this.respostaData == null) {
                this.dateTimeValidated = false;
            }
            let temp = "";
            if (this.dateTimeValidated) {
                temp = this.$moment(this.respostaData).format("YYYY-MM-DD");
                temp += " "+this.respostaHora.HH + ":" + this.respostaHora.mm + ":00";
            }
            this.answer.formRespostaPreenchida.resposta = temp;
        },
        comboboxFillAndVerify(val) {
            let temp = val != null ? val.descricao : null;
            this.options.forEach((m) => {
                m.formRespostaPreenchida.resposta = m.descricao == temp ? temp : null;
            });
            this.forceReloadProp();
        },
        radioFillAndVerify(val) {
            this.options.forEach((m) => {
                m.formRespostaPreenchida.resposta = m.descricao == val ? val : null;
            });
            if (!this.obrigatorio) return;
            let temp = this.options.find((f) => !this.isNull(f.formRespostaPreenchida.resposta));
            this.radioValidated = temp != undefined;
            this.forceReloadProp();
        },
        switchFillAndVerify() {
            if (!this.obrigatorio) return;
            let temp = this.options.find((f) => !this.isNull(f.formRespostaPreenchida.resposta));
            this.switchValidated = temp != undefined;
            this.forceReloadProp();
        },
        checkBoxFillAndVerify() {
            if (!this.obrigatorio) return;
            let temp = this.options.find((f) => !this.isNull(f.formRespostaPreenchida.resposta));
            this.checkBoxValidated = temp != undefined;
        },
    },
};
</script>
<style lang="scss" scoped>
span.validation {
    font-size: 8px;
    color: $red;
    display: block;
    font-weight: 600;
}
.clearfix {
    height: 12px;
}
</style>
